import BrandLogo from "../../atoms/brandLogo";
import { numberFormat } from "../../../utils";
import { useRef } from "react";
import wave from "../../../assets/images/waves pattern.svg";
import {
  Container,
  HeaderImage,
  Heading,
  Steps,
  Card,
  SubDiv,
  Checkout,
} from "./styles";

function PaymentStep1({
  profile,
  setStep1,
  setStep2,
  checkoutData,
  setSelectedFile,
  details,
  hero
}: any) {
  const fileRef = useRef<any>();
  const imageSubmitRef = useRef<any>();

  const submitHandler = () => {
    // setisloading(true);
    setStep1(false);
    setStep2(true);
  };
  const handleImage = (event: any) => {
    event.preventDefault();
    submitHandler();
  };

  const handleFileChange = (e: any) => {
    e.preventDefault();
    const maxSize = 1024 * 1024; // 1 MB
    const maxImageSize = 5 * 1024 * 1024; // 1 MB
    const file = e.target.files[0];

    // Check if the selected file is a PDF.
    if (file && file.type === "application/pdf") {
      if (file.size >= maxSize) {
        // File size exceeds the allowed limit.
        alert("File size is too large. Please choose a smaller file.");
        e.target.value = null; // Clear the input field.
        setSelectedFile(null);
        return;
      }

      setSelectedFile(file);
      setTimeout(() => {
        imageSubmitRef.current.click();
      }, 1000);
      return;
    }

    // File is not a PDF.
    if (file && file.type.startsWith("image/")) {
      if (file.size >= maxImageSize) {
        // File size exceeds the allowed limit.
        alert("File size is too large. Please choose a smaller file.");
        e.target.value = null; // Clear the input field.
        setSelectedFile(null);
      }

      setSelectedFile(file);
      setTimeout(() => {
        imageSubmitRef.current.click();
      }, 500);

      return;
    }
  };

  return (
    <Container className="bg-#FFF] px-[5%]  ">
      <HeaderImage>
        <img src={hero ? hero.headerImage : wave} alt="" />
      </HeaderImage>
      <Heading>
        <BrandLogo src={profile?.image} />
      </Heading>

      <Steps>Step 1 of 2</Steps>
      <Card>
        <SubDiv className="head">
          <p>Pay</p>
          <p className="font-bold">{numberFormat(checkoutData.amount)}</p>
        </SubDiv>
        <SubDiv>
          <h2>Account Number:</h2>
          <p className="text-[0.875em]">{details?.accountNumber}</p>
        </SubDiv>
        <SubDiv>
          <h2>Bank Name:</h2>
          <p className="text-[0.875em]">{details?.bankName}</p>
        </SubDiv>
        <SubDiv>
          <h2>Account Name:</h2>
          <p className="text-[0.875em]">{details?.accountName}</p>
        </SubDiv>

        <form onSubmit={handleImage} encType="multipart/form-data">
          <input
            type="file"
            accept=".pdf, image/*"
            onChange={handleFileChange}
            ref={fileRef}
            hidden
          />
          <Checkout onClick={() => fileRef.current.click()}>
            Attach Receipt
          </Checkout>
          <input type="submit" value="submit" hidden ref={imageSubmitRef} />
        </form>
      </Card>
    </Container>
  );
}

export default PaymentStep1;
